import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class ClearMultiselection extends Action<StorymapState> {
    public static ACTION_TYPE = 'ClearMultiselection';

    public constructor() {
        super(ClearMultiselection.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState): void => {
    [...state.activities, ...state.tasks, ...state.subtasks].forEach((x) => (x.isMultiselected = false));
};

//@ts-ignore
registerReducer(ClearMultiselection.ACTION_TYPE, reducer);
